
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import LoginForm from '@/components/auth/LoginForm';

interface UpdatePasswordFormProps {
  loading: boolean;
  setLoading: (loading: boolean) => void;
  onPasswordUpdate: (password: string) => Promise<void>;
}

const UpdatePasswordForm = ({ loading, setLoading, onPasswordUpdate }: UpdatePasswordFormProps) => {
  return (
    <Card className="w-full max-w-md mx-auto border-0 shadow-sm">
      <CardHeader>
        <CardTitle className="text-center">Set New Password</CardTitle>
        <CardDescription className="text-center">
          Create a new secure password for your account
        </CardDescription>
      </CardHeader>
      
      <CardContent>
        <div className="space-y-4">
          <p className="text-sm text-center text-muted-foreground">
            This link will expire after use. Please create a strong password you'll remember.
          </p>
          
          <LoginForm 
            loading={loading} 
            setLoading={setLoading} 
            isPasswordUpdate={true}
            onPasswordUpdate={onPasswordUpdate}
          />
        </div>
      </CardContent>
      
      <CardFooter className="flex justify-center text-sm text-gray-500">
        Secure authentication powered by Supabase
      </CardFooter>
    </Card>
  );
};

export default UpdatePasswordForm;
